import ButtonLoader from "../Loaders/ButtonLoader";
import addIconGold from "../../assets/Add-icon-gold.svg";
import "./default-view-card.css";
export const DefaultViewCard = ({ doc, slot, handleDocPreview }) => {
  return (
    <div
      className="col-12 col-md-3 col-xl icon-text-box text-center height-25 btn-primary-lighter-2 bg-primary-5-hover font-weight-semibold cursor-pointer"
      id="no-vertical-border"
      onClick={() => handleDocPreview(doc)}
      key={doc.id}
      style={{ background: "var(--primary-10)" }}
    >
      <p className="date">{new Date(doc.created).toLocaleDateString()}</p>
      <span className="icon-wrap">
        <i className="ic ic-19 ic-file-colored cursor-pointer img-19px" />
      </span>
      <p className="name">
        <span className="text-primary-25">{slot?.slot_number}.</span>{" "}
        {doc.file_name || slot?.slot_name}
      </p>
    </div>
  );
};

export const DefaultViewCard2 = ({ doc, handleDocPreview }) => {
  return (
    <div
      className="d-flex icon-text-box-custom  m-b-5 text-center height-25 btn-primary-lighter-2 bg-primary-5-hover font-weight-semibold cursor-pointer"
      id="no-vertical-border"
      onClick={() => handleDocPreview(doc)}
      style={{
        justifyContent: "center",
        marginRight: "5px",
        fontFamily: "var(--bs-body-font-family)",
        background: "var(--primary-10)",
      }}
    >
      <span className="icon-wrap">
        <i className="ic ic-19 ic-file-colored cursor-pointer img-19px" />
      </span>
      <p className="name" style={{ overflow: "hidden" }}>
        {doc?.file_name?.length > 20 ? `${doc.file_name.slice(0, 20)}...` : doc.file_name}
      </p>
    </div>
  );
};

export const DefaultEmptyCard = ({
  slot,
  page,
  item,
  isDragging,
  refetchLoading,
  handleDrop,
  handleUploadPopup,
  isSlotUploading,
}) => {
  return (
    <div
      onDrop={(e) => handleDrop(e, slot.id, page?.page?.id, item?.id)}
      className={`col-12 col-md-3 col-xl icon-text-box text-center dropzone-${slot.id}-${item?.id}-${page.page.id} height-25 btn-primary-lighter-2-empty bg-primary-5-hover font-weight-semibold cursor-pointer`}
      style={{ background: "var(--primary-10)" }}
      id="no-vertical-border"
      onClick={() => handleUploadPopup(slot?.id, item?.id, page?.page?.id)}
    >
      {isSlotUploading(slot?.id, item?.id) && (isDragging || refetchLoading) ? ( // Corrected condition
        <div className="d-flex align-items-center justify-content-center">
          <ButtonLoader />
          <span style={{ marginLeft: "5px" }}>Uploading</span>
        </div>
      ) : (
        // Unchanged code
        <>
          <span className="icon-wrap">
            <i className="ic ic-19 ic-custom-icon-cloud-2 cursor-pointer img-19px" />
          </span>
          {slot.slot_name ? (
            <p
              className="name "
              style={{
                color: "var(--primary-25)",
              }}
            >
              <span className="text-primary-25">{slot?.slot_number}.</span> {slot?.slot_name}
            </p>
          ) : (
            <p
              className="name"
              style={{
                color: "var(--primary-25)",
              }}
            >
              <span className="text-primary-25">{slot?.slot_number}.</span> Available
            </p>
          )}
        </>
      )}
    </div>
  );
};

export const DefaultUploadCard = ({
  page,
  item,
  isDragginguploadingbutton,
  uploadbuttonLoadingid,
  handleDropwithOutpanlesWithoutslots,
  handleUploadPopupwithoutSlots,
}) => {
  return (
    <div
      className="icon-text-box text-center order-last m-r-5 btn-primary-lighter-2 bg-primary-5-hover font-weight-semibold cursor-pointer"
      style={{
        background: "var(--primary-10)",
        width: "70px",
        height: "55px",
        maxWidth: page?.slots?.length <= 1 ? "" : "max-content",
      }}
      id="padding-5px-only-on-add-upload"
      onDrop={(event) => handleDropwithOutpanlesWithoutslots(event, true, page?.page?.id, item?.id)}
      onClick={() => handleUploadPopupwithoutSlots(page?.page?.id)}
    >
      <div className="upload-icon border-0 rounded-0 bg-transparent">
        <div
          className="d-flex align-items-center width-inherit justify-content-center"
          style={{ fontFamily: "var(--bs-body-font-family)" }}
        >
          {isDragginguploadingbutton && item?.id === uploadbuttonLoadingid ? (
            <>
              <ButtonLoader />
              <span style={{ marginLeft: "5px" }}>Uploading..</span>
            </>
          ) : (
            <>
              <span
                className="fw-bold d-flex align-items-center justify-content-center text-gold h5 m-0 height-21 m-r-5"
                style={{
                  width: "15px",
                  minWidth: "15px",
                }}
              >
                <img
                  src={addIconGold}
                  className="ic ic-15 d-flex align-items-center justify-content-center"
                />
              </span>
              <div className="d-flex flex-column">
                <span
                  className="text-primary  pt-0"
                  style={{
                    flexWrap: "wrap",
                    fontFamily: "Inter",
                  }}
                >
                  Save
                </span>
                <span
                  className="text-primary  pt-0"
                  style={{
                    flexWrap: "wrap",
                    fontFamily: "Inter",
                  }}
                >
                  to
                </span>
                <span
                  className="text-primary  pt-0"
                  style={{
                    flexWrap: "wrap",
                    fontFamily: "Inter",
                  }}
                >
                  Page
                </span>
              </div>
              {/* <span className="text-primary name height-21">
                To {page?.page?.name} Page
              </span> */}
            </>
          )}
        </div>
      </div>
    </div>
    // <div
    //     className="col-12 col-md-6 col-xl-3 icon-text-box text-center order-last font-weight-semibold cursor-pointer detailed-empty-card"
    //     onDrop={(event) =>
    //         handleDropwithOutpanlesWithoutslots(
    //             event,
    //             true,
    //             page?.page?.id,
    //             item?.id
    //         )
    //     }
    //     onClick={() =>
    //         handleUploadPopupwithoutSlots(page?.page?.id)
    //     }
    // >
    //     <div className="upload-icon border-0 rounded-0 bg-transparent">
    //         <div className="d-flex align-items-center width-inherit justify-content-center">
    //             {isDragginguploadingbutton &&
    //                 item?.id === uploadbuttonLoadingid ? (
    //                 <>
    //                     <ButtonLoader />
    //                     <span style={{ marginLeft: "5px" }}>
    //                         Uploading..
    //                     </span>
    //                 </>
    //             ) : (
    //                 <p className="detailed-empty-card-sub-head" style={{ fontWeight: 600, color: 'var(--fc-neutral-text-color)' }}>
    //                     Upload Document to Page{" "}
    //                 </p>
    //             )}
    //         </div>
    //     </div>
    // </div>
  );
};

export const DefaultUploadCardWithoutPanelsWithoutSlots = ({
  page,
  isDragginguploadingbutton,
  handleDropwithOutpanlesWithoutslots,
  handleUploadPopupwithoutSlots,
}) => {
  return (
    <div
      className=" d-flex m-b-5 icon-text-box text-center order-last m-r-5 btn-primary-lighter-2 bg-primary-5-hover font-weight-semibold cursor-pointer"
      style={{
        background: "var(--primary-10)",
        width: "70px",
        height: "55px",
        maxWidth: page?.slots?.length <= 1 ? "" : "max-content",
      }}
      id="padding-5px-only-on-add-upload"
      onDrop={(event) => handleDropwithOutpanlesWithoutslots(event, false, page?.page?.id, 0)}
      onClick={() => handleUploadPopupwithoutSlots(page?.page?.id)}
    >
      <div className="upload-icon border-0 rounded-0 bg-transparent dropzone-{data.page.id}-{clientProvider.id}">
        <div
          className="d-flex align-items-center width-inherit justify-content-center"
          style={{ fontFamily: "var(--bs-body-font-family)" }}
        >
          {isDragginguploadingbutton ? (
            <>
              <ButtonLoader />
              <span style={{ marginLeft: "5px" }}>Uploading...</span>
            </>
          ) : (
            <>
              <span
                className="fw-bold d-flex align-items-center justify-content-center text-gold h5 m-0 height-21 m-r-5"
                style={{
                  width: "15px",
                  minWidth: "15px",
                }}
              >
                <img
                  src={addIconGold}
                  className="ic ic-15 d-flex align-items-center justify-content-center"
                />
              </span>
              <div className="d-flex flex-column">
                <span
                  className="text-primary  pt-0"
                  style={{
                    flexWrap: "wrap",
                    fontFamily: "Inter",
                  }}
                >
                  Save
                </span>
                <span
                  className="text-primary  pt-0"
                  style={{
                    flexWrap: "wrap",
                    fontFamily: "Inter",
                  }}
                >
                  to
                </span>
                <span
                  className="text-primary  pt-0"
                  style={{
                    flexWrap: "wrap",
                    fontFamily: "Inter",
                  }}
                >
                  Page
                </span>
              </div>
              {/* <span className="text-primary name height-21">
                To {page?.page?.name} Page
              </span> */}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const DefaultUploadCardNoLoader = ({
  page,
  item,
  handleDropwithOutpanlesWithoutslots,
  handleUploadPopupwithoutSlots,
}) => {
  return (
    <div
      className="icon-text-box text-center p-l-5 p-r-5 order-last m-r-5 btn-primary-lighter-2 bg-primary-5-hover font-weight-semibold cursor-pointer"
      id="padding-5px-only-on-add-upload"
      style={{
        background: "var(--primary-10)",
        width: "70px",
        height: "55px",
        maxWidth: page?.slots?.length <= 1 ? "" : "max-content",
      }}
      onDrop={(event) => handleDropwithOutpanlesWithoutslots(event, true, page?.page?.id, item?.id)}
      onClick={() => handleUploadPopupwithoutSlots(page?.page?.id)}
    >
      <div className="upload-icon border-0 rounded-0 bg-transparent">
        <div
          className="d-flex align-items-center width-inherit justify-content-center"
          style={{ fontFamily: "var(--bs-body-font-family)" }}
        >
          {/* {isDragginguploadingbutton &&
                        item?.id === uploadbuttonLoadingid ? (
                        <>
                            <ButtonLoader />
                            <span style={{ marginLeft: "5px" }}>
                                Uploading..
                            </span>
                        </>
                    ) : ( */}
          {/* <> */}
          <span
            className="fw-bold d-flex align-items-center justify-content-center text-gold h5 m-0 height-21 m-r-5"
            style={{
              width: "15px",
              minWidth: "15px",
            }}
          >
            <img
              src={addIconGold}
              className="ic ic-15 d-flex align-items-center justify-content-center"
            />
          </span>
          <div className="d-flex flex-column">
            <span
              className="text-primary  pt-0"
              style={{
                flexWrap: "wrap",
                fontFamily: "Inter",
              }}
            >
              Save
            </span>
            <span
              className="text-primary  pt-0"
              style={{
                flexWrap: "wrap",
                fontFamily: "Inter",
              }}
            >
              to
            </span>
            <span
              className="text-primary  pt-0"
              style={{
                flexWrap: "wrap",
                fontFamily: "Inter",
              }}
            >
              Page
            </span>
          </div>
          {/* <span className="text-primary name height-21">To {page?.page?.name} Page</span> */}
          {/* </>
                    )} */}
        </div>
      </div>
    </div>
  );
};
